import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import ConnectMonitor from "./ConnectMonitor";
import TestYourMonitor from "./TestYourMonitor";
import WeatherAlertProjects from "./WeatherAlertProjects";
import ComingSoon from "./ComingSoon";
import ProjectStartForm from "../Builder/Components/sidebar/ProjectStartForm";
import ComponentSelector from "../Common/ComponentSelector";
import LightBroadcast from "../Broadcast/LightBroadcast";

export const connectMonitorOptions = [
  {
    name: "IsComponent",
    heading: "Workflow",
    info: (
      <div>
        <div className="fw-bold">About Workflow</div>
        <div>
          Connect your monitor to an existing workflow so that monitoring events
          can automatically trigger actions and pass relevant information into a
          workflow project. This ensures that alerts, data, and responses are
          seamlessly integrated into your operational processes.
        </div>
      </div>
    ),
    isDisabled: false,
  },
  {
    name: "IsCommunication",
    heading: "Communication",
    info: (
      <div>
        <div className="fw-bold">About Communication </div>
        <div>
          Connect your monitor to communication services like SMS, email, voice,
          or API to ensure alerts and data are delivered to the right people or
          systems in real time.
        </div>
      </div>
    ),
    isDisabled: false,
  },

  {
    name: "IsAsset",
    heading: "Asset",
    info: (
      <div>
        <div className="fw-bold">About Asset </div>
        <div>
          Connect your monitor to asset management services to ensure alerts and
          data are delivered to the right people or systems in real time.
        </div>
      </div>
    ),
    isDisabled: false,
  },

  // {
  //   name: "IsApi",
  //   heading: "API",
  //   info: (
  //     <div>
  //       <div className="fw-bold">About API </div>
  //       <div>
  //         Integrate your monitor with the API service to automatically send and
  //         receive data between systems. This allows you to trigger workflows,
  //         update external platforms, or log events programmatically in real
  //         time.
  //       </div>
  //     </div>
  //   ),
  //   isDisabled: true,
  // },
];

export const isServiceValid = (service, monitor, monitorBroadcasts) => {
  let isValid = false;
  const communicationBroadcast = monitorBroadcasts?.communication?.broadcast;
  const communicationSendList = monitorBroadcasts?.communication?.sendList;
  const assetBroadcast = monitorBroadcasts?.asset?.broadcast;

  if (
    service === "IsComponent" &&
    !!Object.keys(monitor.TriggerMonitorVariables || {}).length
  ) {
    isValid = true;
  } else if (
    service === "IsCommunication" &&
    communicationBroadcast?.Messages?.some((m) =>
      m.Message.EditorState.blocks?.some((b) => !!b.text)
    ) &&
    (!!communicationSendList?.contacts?.length ||
      !!communicationSendList?.contactSets?.length)
  ) {
    isValid = true;
  } else if (
    service === "IsAsset" &&
    assetBroadcast?.Messages?.some((m) =>
      m.Message.EditorState.blocks?.some((b) => !!b.text)
    ) &&
    !!monitor?.WithAssets?.length
  ) {
    isValid = true;
  }
  return isValid;
};

export default function MonitoringConnect({
  monitor,
  setMonitor,
  monitorBroadcasts,
  setMonitorBroadcasts,
}) {
  const [connectMonitor, setConnectMonitor] = useState("IsComponent");

  return (
    <div>
      <Row className="mt-3">
        <Col xl={5} xs={12} className="border-end">
          <div className="me-xl-5 mb-2 mb-xl-0">
            <ConnectMonitor
              monitor={monitor}
              monitorBroadcasts={monitorBroadcasts}
              connectMonitor={connectMonitor}
              setConnectMonitor={setConnectMonitor}
            />
          </div>
        </Col>
        <Col xl={7}>
          <div className="ms-xl-5 mt-xl-2">
            <Form.Check
              disabled={
                !isServiceValid(connectMonitor, monitor, monitorBroadcasts)
              }
              type="switch"
              id="custom-switch"
              label="Draft"
              className="mb-3"
              checked={!monitor[connectMonitor]}
              onChange={(e) => {
                setMonitor({
                  ...monitor,
                  [connectMonitor]: !e.target.checked,
                });
              }}
            />
            {["IsCommunication"].includes(connectMonitor) && (
              <div style={{ minHeight: 400 }}>
                <LightBroadcast
                  tokenTags={[
                    "contact_field",
                    "imported_contact_field",
                    "current_time",
                    "customer_name",
                    "monitor",
                    ...(monitor.Kind === "ping" ? ["api", "ping_status"] : []),
                    ...(monitor.Kind === "weather" ? ["weather"] : []),
                  ]}
                  showSendButton={false}
                  showSendTestButton
                  broadcastState={monitorBroadcasts.communication?.broadcast}
                  initialSendList={monitorBroadcasts.communication?.sendList}
                  setBroadcastState={(b) => {
                    const newMonitorBroadcasts = {
                      ...monitorBroadcasts,
                      communication: {
                        ...(monitorBroadcasts.communication || {}),
                        broadcast: b,
                      },
                    };
                    setMonitorBroadcasts(newMonitorBroadcasts);
                    if (
                      !isServiceValid(
                        "IsCommunication",
                        monitor,
                        newMonitorBroadcasts
                      )
                    ) {
                      setMonitor({ ...monitor, IsCommunication: false });
                    }
                  }}
                  setSendList={(sl) => {
                    const newMonitorBroadcasts = {
                      ...monitorBroadcasts,
                      communication: {
                        ...(monitorBroadcasts.communication || {}),
                        sendList: sl,
                      },
                    };
                    setMonitorBroadcasts(newMonitorBroadcasts);

                    if (
                      !isServiceValid(
                        "IsCommunication",
                        monitor,
                        newMonitorBroadcasts
                      )
                    ) {
                      setMonitor({ ...monitor, IsCommunication: false });
                    }
                  }}
                  showAssetSelection={false}
                />
              </div>
            )}

            {["IsAsset"].includes(connectMonitor) && (
              <div style={{ minHeight: 400 }}>
                <LightBroadcast
                  tokenTags={[
                    "contact_field",
                    "imported_contact_field",
                    "current_time",
                    "customer_name",
                    "monitor",
                    ...(monitor.Kind === "ping" ? ["api", "ping_status"] : []),
                    ...(monitor.Kind === "weather" ? ["weather"] : []),
                    "assets",
                  ]}
                  showSendButton={false}
                  showSendTestButton
                  broadcastState={monitorBroadcasts.asset?.broadcast}
                  initialSendList={{ assets: monitor.WithAssets || [] }}
                  setBroadcastState={(b) => {
                    const newMonitorBroadcasts = {
                      ...monitorBroadcasts,
                      asset: { ...(monitorBroadcasts.asset || {}), broadcast: b },
                    };
                    setMonitorBroadcasts(newMonitorBroadcasts);
                    if (
                      !isServiceValid("IsAsset", monitor, newMonitorBroadcasts)
                    ) {
                      setMonitor({ ...monitor, IsAsset: false });
                    }
                  }}
                  setSendList={(sl) => {
                    const newMonitor = {
                      ...monitor,
                      WithAssets: sl?.assets || [],
                    };
                    if (
                      !isServiceValid("IsAsset", newMonitor, monitorBroadcasts)
                    ) {
                      newMonitor.IsAsset = false;
                    }
                    setMonitor(newMonitor);
                  }}
                  showRecipientsSelection={false}
                  showAssetSelectionOnTop
                />
              </div>
            )}

            {["IsApi"].includes(connectMonitor) && (
              <div
                className="d-flex flex-column align-items-center justify-content-center"
                style={{ minHeight: 400 }}
              >
                {" "}
                <ComingSoon />
                {/* <TestYourMonitor /> */}
              </div>
            )}

            {/* {monitor.Kind === "weather" && connectMonitor === "IsComponent" && (
              <div className="bg-purple-gradient-darker-reverse rounded-4 p-4 px-5">
                <WeatherAlertProjects
                  weatherAlertData={monitor.WeatherAlert}
                  setWeatherAlertData={(WeatherAlert) =>
                    setMonitor({ ...monitor, WeatherAlert })
                  }
                />
              </div>
            )} */}
            {["ping", "weather"].includes(monitor.Kind) &&
              connectMonitor === "IsComponent" && (
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-4 px-5">
                  <ComponentSelector
                    interfaceType={
                      monitor.Kind === "ping" ? "ping-monitor" : "weather-alert"
                    }
                    selected={monitor.TriggerMonitorVariables}
                    onSelect={(variables) => {
                      const newMonitor = {
                        ...monitor,
                        TriggerMonitorVariables: variables,
                      };
                      if (
                        !isServiceValid(
                          "IsComponent",
                          newMonitor,
                          monitorBroadcasts
                        )
                      ) {
                        newMonitor.IsComponent = false;
                      }
                      setMonitor(newMonitor);
                    }}
                  />
                </div>
              )}
            {/* {monitor.WeatherAlert?.Projects?.length > 0 && (
              <div className="bg-purple-gradient-darker-reverse rounded-4 p-4 px-5 mt-3">
                <ProjectStartForm
                  projectID={
                    monitor.WeatherAlert?.Projects?.[0]?.selectedProject?.ID
                  }
                  showHiddenVariables
                  hideStartButton
                  onChange={(formData) => setMonitor({ ...monitor, formData })}
                />
              </div>
            )} */}
          </div>
        </Col>
      </Row>
    </div>
  );
}
